export const aciNoiseFreeRooms = {
    iconName: 'noise-free-rooms',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.32 6.079a8.978 8.978 0 0012.677 12.677L5.319 6.08zm.706-.707l12.678 12.677A8.978 8.978 0 006.027 5.372zm13.047 13.742a9.947 9.947 0 002.916-7.05c0-5.51-4.467-9.978-9.978-9.978-5.51 0-9.978 4.467-9.978 9.978 0 5.51 4.468 9.978 9.978 9.978a9.947 9.947 0 007.056-2.922l.006-.006z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M14.68 5.524c-.058.025-1.316.692-2.797 1.482L9.191 8.443H7.964c-.793 0-1.267.007-1.34.02a.647.647 0 00-.465.362l-.05.105v6.268l.057.112c.07.139.209.265.346.317.102.038.14.039 1.38.039h1.276l2.757 1.47c1.725.92 2.793 1.478 2.853 1.493a.626.626 0 00.568-.16.595.595 0 00.193-.357c.015-.089.02-1.84.016-6.135l-.005-6.011-.066-.13a.594.594 0 00-.546-.35.465.465 0 00-.258.038zm-2.551 2.803l-2.14 1.141-.005 2.59-.005 2.59 2.141 1.142c1.178.628 2.145 1.138 2.15 1.133.005-.005.007-2.198.004-4.873l-.005-4.865-2.14 1.142zM7.38 12.054v2.332H8.7V9.723H7.38v2.331z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
